import React from 'react'

const Icon = (props) => {
  const { width, height, viewBox, cx, cy, r, fill, stroke, strokeWidth } = props

  return (
    <svg
      width={width || '31'}
      height={height || '31'}
      viewBox={viewBox || '0 0 31 31'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={cx || '15.5'}
        cy={cy || '15.5'}
        r={r || '13.5'}
        stroke={stroke || 'white'}
        strokeWidth={strokeWidth || '4'}
        fill={fill || 'none'}
      />
    </svg>
  )
}

export default Icon
